"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.ButtonStatusTypes = exports.ButtonKindTypes = exports.ButtonSizeTypes = exports.ButtonHTMLTypes = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const types_1 = require("../types");
const ForwardRefHOC_1 = __importDefault(require("../ForwardRefHOC"));
const IcSuccessFilledSm_1 = __importDefault(require("../Icons/IcSuccessFilledSm"));
const Box_1 = require("../Box");
const VisuallyHidden_1 = __importDefault(require("../VisuallyHidden"));
exports.ButtonHTMLTypes = types_1.tuple('submit', 'button', 'reset');
exports.ButtonSizeTypes = types_1.tuple('small', 'big');
exports.ButtonKindTypes = types_1.tuple('primary', 'secondary', 'text', 'primary-reversed');
exports.ButtonStatusTypes = types_1.tuple('default', 'loading', 'success');
function mapKindToClassName(kind) {
    const base = 'button';
    switch (kind) {
        case 'primary':
            return base;
        case 'secondary':
            return `${base}-ghost`;
        case 'text':
            return `${base}-text`;
        case 'primary-reversed':
            return `${base}-primary-reversed`;
        default:
            return base;
    }
}
const Button = (props) => {
    const { forwardedRef, className, htmlType, size, kind, status = 'default' } = props, restProps = __rest(props, ["forwardedRef", "className", "htmlType", "size", "kind", "status"]);
    const baseClassName = mapKindToClassName(kind);
    const finalClassName = classnames_1.default(baseClassName, `status--${status}`, {
        [`${size}`]: size
    }, className);
    return (react_1.default.createElement("button", Object.assign({ ref: forwardedRef, className: finalClassName, type: htmlType }, restProps, { "aria-live": 'polite' }), renderContent(props.children, status)));
};
exports.Button = Button;
const renderContent = (children, status) => {
    switch (status) {
        case 'loading':
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: 'calcul-animation' },
                    react_1.default.createElement("span", { className: 'dot' }),
                    react_1.default.createElement("span", { className: 'dot' }),
                    react_1.default.createElement("span", { className: 'dot' })),
                react_1.default.createElement(VisuallyHidden_1.default, null, "Loading")));
        case 'success':
            return (react_1.default.createElement(Box_1.Box, { alignItems: 'center', justifyContent: 'center' },
                react_1.default.createElement(IcSuccessFilledSm_1.default, { width: 32, fill: 'interaction-primary' }),
                react_1.default.createElement(VisuallyHidden_1.default, null, "Successful")));
        case 'default':
            return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
};
exports.Button.displayName = 'Button';
exports.default = ForwardRefHOC_1.default(exports.Button);
